export default __webpack_public_path__ + "static/media/porshia-close.360f97c2.jpg";